const SAFE_SCHEMES = new Set(["http:", "https:", "mailto:"]);

/**
 * Validate a link href before rendering it. Returns the href when it's a relative
 * URL or uses an allow-listed scheme (http/https/mailto), else `undefined` — so a
 * `javascript:`/`data:`/`vbscript:` href is dropped rather than rendered as a
 * clickable link. `target="_blank" rel="noreferrer"` already neutralizes most of
 * the risk on these links, so this is defense-in-depth.
 */
export function safeHref(href: string | null | undefined): string | undefined {
  if (!href) return undefined;
  const trimmed = href.trim();
  if (!trimmed) return undefined;
  let scheme: string;
  try {
    // The dummy base resolves relative URLs (they inherit https → allowed) and
    // lets us read the scheme of absolute ones via the parser, which strips the
    // whitespace/control chars a naive prefix check could be fooled by.
    scheme = new URL(trimmed, "https://relative.invalid").protocol;
  } catch {
    return undefined;
  }
  return SAFE_SCHEMES.has(scheme) ? trimmed : undefined;
}
